import { PaymentPlanType } from '../../types/PaymentPlanType';
import { BaseWebComponentTranslator } from '../../../framework/BaseWebComponentTranslator';

export function getTranslatedPaymentPlan(paymentPlanType: PaymentPlanType): string {
  const translator = BaseWebComponentTranslator.getInstance();

  switch (paymentPlanType) {
    case PaymentPlanType.LICENSE_NONE:
      return translator.translateFn('None');
    case PaymentPlanType.YEARLY:
      return translator.translateFn('Yearly');
    case PaymentPlanType.MONTHLY:
      return translator.translateFn('Monthly');
    default:
      return '';
  }
}
